import isEmpty from 'lodash/isEmpty'

import {
  PAYMENT_ADVERTISING_TYPES,
  landingPaymentAdvertising,
  productPaymentAdvertising,
} from '@payment'
import { MAX_RATING } from '@reviews/constants'

import translations from '../../components/TrustList/TrustList.translations'

const ratingsItem = ({ ratings }) => {
  return {
    id: 'reassurance_payment_service_rate',
    icon: 'IconStarOutlined',
    i18n: {
      translation: translations.paymentServiceAdviceNew,
      params: {
        rate: ratings.averageRate,
        maxRate: MAX_RATING,
      },
    },
  }
}

const aboutUsItemConfig = () => {
  return {
    id: 'reassurance_payment_page_verified',
    icon: 'IconBadge',
    i18n: {
      translation: translations.paymentPageVerified,
    },
  }
}

export const paymentAdvertisingResults = ({
  paymentAdvertisingType,
  paymentMethods,
  advertisingOptions,
}) => {
  switch (paymentAdvertisingType) {
    case PAYMENT_ADVERTISING_TYPES.LANDING:
      return landingPaymentAdvertising(paymentMethods, advertisingOptions)

    case PAYMENT_ADVERTISING_TYPES.PRODUCT:
      return productPaymentAdvertising(paymentMethods, advertisingOptions)
        .advertised

    default:
      return []
  }
}

const paymentWithAdvertising = ({
  paymentAdvertisingType,
  paymentMethods,
  advertisingOptions,
}) => {
  const item = paymentAdvertisingResults({
    paymentAdvertisingType,
    paymentMethods,
    advertisingOptions,
  })

  if (isEmpty(item)) return undefined

  if (item.icon === '/img/payment/methods-v2/card.svg' || !item.icon) {
    item.icon = 'IconPayment'
  }

  return {
    id: 'reassurance_payment_with_advertising',
    icon: item.icon,
    i18n: {
      translation: item.label,
    },
  }
}

const displayDefaultPaymentItem = ({ ratings }) => {
  const hasGoodReviews = ratings.reviewsCount >= 10 && ratings.averageRate >= 4

  return hasGoodReviews ? ratingsItem({ ratings }) : aboutUsItemConfig()
}

export const paymentItem = ({
  paymentAdvertisingType,
  ratings,
  paymentMethods,
  advertisingOptions,
}) => {
  return (
    paymentWithAdvertising({
      paymentAdvertisingType,
      paymentMethods,
      advertisingOptions,
    }) || displayDefaultPaymentItem({ ratings })
  )
}
